<!--Copyright (c) Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

<div class="lf-repository-browser-header">
  <lfint-breadcrumbs
    [breadcrumbs]="breadcrumbs"
    (breadcrumbClicked)="onBreadcrumbNavigation(toBreadcrumbNavigationEvent($event))"
  >
  </lfint-breadcrumbs>
  <ng-content select="[lf-toolbar]"></ng-content>
</div>
<div
  class="lf-repo-entry-container"
  [attr.tabindex]="isLoading || shouldShowErrorMessage || shouldShowEmptyMessage ? 0 : -1"
>
  @if (isLoading) {
    <lfint-loader-component class="lf-text-body lf-no-user-select"></lfint-loader-component>
  }
  @if (!isLoading && (shouldShowErrorMessage || shouldShowEmptyMessage)) {
    <div id="message-display">
      @if (shouldShowErrorMessage) {
        <div class="lf-text-body lf-text-error lf-no-user-select">{{ AN_ERROR_OCCURED | async }}</div>
      }
      @if (shouldShowEmptyMessage) {
        <div class="lf-text-body lf-no-user-select">{{ THIS_FOLDER_IS_EMPTY | async }}</div>
      }
    </div>
  }
  <div [hidden]="shouldShowErrorMessage || shouldShowEmptyMessage" [ngStyle]="{ height: '100%' }">
    <lfint-selection-list-component
      [hidden]="isLoading || shouldShowErrorMessage || shouldShowEmptyMessage"
      [uniqueIdentifier]="repoBrowserUniqueId"
      [listItems]="currentFolderChildren"
      [multipleSelection]="multiple"
      [itemSize]="item_size"
      [pageSize]="page_size"
      (scrollChanged)="onScroll()"
      [listItemRef]="listOption"
      (itemDoubleClicked)="onDblClickAsync($event)"
      (itemSelected)="onItemSelected($event)"
      (itemFocused)="onEntryFocused($event)"
      (refreshData)="refreshAsync(false)"
    >
      <ng-template #listOption let-item="value">
        @if (getIcons(item).length > 0) {
          <div class="fixed-size-icon-container lf-no-user-select">
            @for (icon of getIcons(item); track icon) {
              <img src="{{ icon }}" alt="" class="lf-entry-icon" />
            }
          </div>
        }
        <div title="{{ item?.name }}" class="lf-ellipsis-label lf-no-user-select">{{ item?.name }}</div>
      </ng-template>
    </lfint-selection-list-component>
  </div>
</div>
